// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1sTq0MpQuCTSyh {\n  margin-left: 8px;\n}\n._2X_eLbqec7bt07 {\n  display: inline-flex;\n  font-weight: 600;\n  color: #5e6c84;\n}\n._1RIk1Ra33KeD7M {\n  display: inline-flex;\n  font-size: 12px;\n  color: #5e6c84;\n}\n.flk7K0Rc4ldrLc {\n  display: inline-flex;\n  height: 20px;\n  width: 20px;\n  justify-content: center;\n  align-items: center;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewCopyComponent": "_1sTq0MpQuCTSyh",
	"viewCopyText": "_2X_eLbqec7bt07",
	"viewCopyTextSmall": "_1RIk1Ra33KeD7M",
	"iconViewCopy": "flk7K0Rc4ldrLc"
};
export default ___CSS_LOADER_EXPORT___;
